import { render, staticRenderFns } from "./StorageSpaceDropdown.vue?vue&type=template&id=03d57296&"
import script from "./StorageSpaceDropdown.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports